import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  background: ${({ theme }) => theme.colors.background.primary};
  padding-bottom: 60px;
`

export const Content = styled.div`
  flex: 1;
  padding: 24px;
  overflow-y: auto;
`

export const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
  color: ${({ theme }) => theme.colors.text.secondary};
`

export const ErrorContainer = styled.div`
  padding: 16px;
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.danger}10;
  border: 1px solid ${({ theme }) => theme.colors.danger}30;
  color: ${({ theme }) => theme.colors.danger};
  margin: 16px 0;
`
